import { Component, Inject, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UpdateStatusDialogComponent } from '..';
import { ContactsService } from '../../../../../core/lists/_services';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'kt-view-file-dialog',
  templateUrl: './view-file-dialog.component.html',
  styleUrls: ['./view-file-dialog.component.scss'],
})
export class ViewFileDialogComponent implements OnInit {
  selectedStatusForUpdate = new FormControl('');
  viewLoading = false;
  loadingAfterSubmit = false;
  avatars: any = [];
  page = 0;
  src = new BehaviorSubject(null);
  disabled = false;

  constructor(
    private contactService: ContactsService,
    public dialogRef: MatDialogRef<UpdateStatusDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  ngOnInit() {
    this.contactService.contactAvatarHistory(this.data.type, this.data.id).subscribe((res) => {
      if (res.data && res.data.length === 0) {
        return;
      }
      this.avatars = res.data;
      this.getPresigned(res.data[this.page].uuid);
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onSaveClick(): void {
    this.dialogRef.close({
      pre: this.src.value,
      uuid: this.avatars[this.page].uuid,
      isUpdated: true,
    });
  }

  move(number: number) {
    if (number >= this.avatars.length || number < 0) {
      return;
    }
    this.page = number;
    this.disabled = true;
    this.getPresigned(this.avatars[this.page].uuid);
  }

  getPresigned(uuid) {
    this.contactService.avatarPresigned(uuid).subscribe((res) => {
      this.src.next(res.data.url);
      this.disabled = false;
      return;
    });
  }
}
